<template>
  <div class="project-sharing">
    <div class="mb-4">
      <h5 class="section-title">Manage Users</h5>
    </div>
    
    <!-- Tabs for different user types -->
    <el-tabs v-model="activeTab" class="user-tabs">
      <!-- Managers Tab -->
      <el-tab-pane label="Managers" name="managers">
        <div class="d-flex justify-content-end mb-3">
          <button
            type="button"
            class="btn btn-primary share-btn"
            @click="openInviteModal('MANAGER')"
          >
            <i class="el-icon-plus mr-2"></i> Add New Manager
          </button>
        </div>
        <div v-if="managers.length" class="user-table-container">
          <el-table
            :data="managers"
            style="width: 100%"
            :default-sort="{prop: 'first_name', order: 'ascending'}"
            class="custom-table"
            :row-class-name="tableRowClassName"
            :header-cell-style="{background: '#f8fafc', color: '#475569', fontWeight: '600', borderBottom: '2px solid #e2e8f0'}"
            :cell-style="{padding: '12px 8px'}"
          >
            <el-table-column
              prop="first_name"
              label="FIRST NAME"
              sortable
              min-width="120">
              <template slot-scope="scope">
                <div class="user-name">
                  <div class="user-avatar">
                    {{ getInitials(scope.row.first_name, scope.row.last_name) }}
                  </div>
                  <span>{{ scope.row.first_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="last_name"
              label="LAST NAME"
              sortable
              min-width="120">
            </el-table-column>
            <el-table-column
              prop="email"
              label="EMAIL"
              sortable
              min-width="200">
              <template slot-scope="scope">
                <div class="email-cell">
                  <i class="el-icon-message" style="margin-right: 5px; color: #64748b;"></i>
                  {{ scope.row.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="note"
              label="NOTE"
              min-width="180">
              <template slot-scope="scope">
                <div class="note-cell" :title="scope.row.note || ''">
                  {{ scope.row.note || '—' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="STATUS"
              sortable
              min-width="120"
              align="center">
              <template slot-scope="scope">
                <div class="status-tag" :class="scope.row.status === 'Joined' ? 'status-active' : 'status-pending'">
                  <span class="status-indicator"></span>
                  {{ scope.row.status }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ACTIONS"
              min-width="100"
              align="center">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                  class="delete-btn"
                  @click="removeUserConfirmation(scope.row, project)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-users p-4 text-center">
          <i class="el-icon-user" style="font-size: 48px; color: #ccc;"></i>
          <p class="mt-3">No managers have been assigned to this project yet</p>
          <button class="btn btn-outline-primary mt-2" @click="openInviteModal('MANAGER')">Add Manager</button>
        </div>
      </el-tab-pane>

      <!-- Field Users Tab -->
      <el-tab-pane label="Field Users" name="fieldUsers">
        <div class="d-flex justify-content-end mb-3">
          <button
            type="button"
            class="btn btn-success android-btn"
            @click="goToAssignments"
          >
            <i class="el-icon-mobile-phone mr-2"></i> Add Field User
          </button>
        </div>
        <assigned-user-list :project-id="parseInt(projectId)" :embedded="true" />
      </el-tab-pane>

      <!-- Viewers Tab -->
      <el-tab-pane label="Viewers" name="viewers">
        <div class="d-flex justify-content-end mb-3">
          <button
            type="button"
            class="btn btn-primary share-btn"
            @click="openInviteModal('VIEWER')"
          >
            <i class="el-icon-plus mr-2"></i> Add New Viewer
          </button>
        </div>
        <div v-if="viewers.length" class="user-table-container">
          <el-table
            :data="viewers"
            style="width: 100%"
            :default-sort="{prop: 'first_name', order: 'ascending'}"
            class="custom-table"
            :row-class-name="tableRowClassName"
            :header-cell-style="{background: '#f8fafc', color: '#475569', fontWeight: '600', borderBottom: '2px solid #e2e8f0'}"
            :cell-style="{padding: '12px 8px'}"
          >
            <el-table-column
              prop="first_name"
              label="FIRST NAME"
              sortable
              min-width="120">
              <template slot-scope="scope">
                <div class="user-name">
                  <div class="user-avatar">
                    {{ getInitials(scope.row.first_name, scope.row.last_name) }}
                  </div>
                  <span>{{ scope.row.first_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="last_name"
              label="LAST NAME"
              sortable
              min-width="120">
            </el-table-column>
            <el-table-column
              prop="email"
              label="EMAIL"
              sortable
              min-width="200">
              <template slot-scope="scope">
                <div class="email-cell">
                  <i class="el-icon-message" style="margin-right: 5px; color: #64748b;"></i>
                  {{ scope.row.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="note"
              label="NOTE"
              min-width="180">
              <template slot-scope="scope">
                <div class="note-cell" :title="scope.row.note || ''">
                  {{ scope.row.note || '—' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="STATUS"
              sortable
              min-width="120"
              align="center">
              <template slot-scope="scope">
                <div class="status-tag" :class="scope.row.status === 'Joined' ? 'status-active' : 'status-pending'">
                  <span class="status-indicator"></span>
                  {{ scope.row.status }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ACTIONS"
              min-width="100"
              align="center">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                  class="delete-btn"
                  @click="removeUserConfirmation(scope.row, project)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-users p-4 text-center">
          <i class="el-icon-view" style="font-size: 48px; color: #ccc;"></i>
          <p class="mt-3">No viewers have been assigned to this project yet</p>
          <button class="btn btn-outline-primary mt-2" @click="openInviteModal('VIEWER')">Add Viewer</button>
        </div>
      </el-tab-pane>
    </el-tabs>
    
    <div v-if="!project" class="loading-container p-5 text-center">
      <i class="el-icon-loading" style="font-size: 32px;"></i>
      <p class="mt-3">Loading project details...</p>
    </div>

    <el-dialog
      title="Add User"
      :visible.sync="inviteDialogVisible"
      class="invite-user-dialog"
      width="60%"
    >
      <div>
        <el-form
          ref="inviteUserForm"
          :model="inviteUserModel"
          label-width="120px"
          label-position="top"
        >
            <div class="row">
                <div class="col-12">
                    <el-form-item
                        label="Select role"
                        prop="user_role"
                        :rules="[{ required: true, message: 'Please select role' }]"
                    >
                        <el-radio-group v-model="inviteUserModel.user_role">
                            <el-radio
                                v-for="role in roles"
                                :key="role.id"
                                :label="role.id"
                            >{{ role.role_name }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
          <div class="row">
            <div class="col">
              <el-form-item
                label="First name"
                prop="first_name"
                :rules="[{ required: true, message: 'First name is required' }]"
              >
                <el-input v-model="inviteUserModel.first_name"> </el-input>
              </el-form-item>
            </div>
            <div class="col">
              <el-form-item
                label="Last name"
                prop="last_name"
                :rules="[{ required: true, message: 'Last name is required' }]"
              >
                <el-input v-model="inviteUserModel.last_name"> </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <el-form-item
                label="Email"
                prop="email"
                :rules="[{ required: true, message: 'Email is required' }]"
              >
                <el-input v-model="inviteUserModel.email" @blur="checkEmail()">
                </el-input>
              </el-form-item>
            </div>
          </div>

          <el-form-item label="Note" prop="note">
            <el-input v-model="inviteUserModel.note"> </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="inviteDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitInviteUser">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Dialog,
  Button,
  Input,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  Table,
  TableColumn,
  Select,
  Option,
  Tag,
  Tabs,
  TabPane
} from "element-ui";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import AssignedUserList from './AssignUser/AssignedUserList.vue';

export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tag.name]: Tag,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    AssignedUserList
  },
  data() {
    return {
      project: null,
      managers: [],
      viewers: [],
      roles: [],
      inviteDialogVisible: false,
      activeTab: 'managers',
            inviteUserModel: {
        organisation_id: "",
        first_name: "",
        last_name: "",
        email: "",
        user_id: null,
        project_id: "",
        user_role: "",
        note: "",
      },
    };
  },
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  methods: {
    getInitials(firstName, lastName) {
      const firstInitial = firstName && firstName.length > 0 ? firstName.charAt(0).toUpperCase() : '?';
      const lastInitial = lastName && lastName.length > 0 ? lastName.charAt(0).toUpperCase() : '';
      return firstInitial + lastInitial;
    },
    
    tableRowClassName({row, rowIndex}) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    
    getProjectDetails() {
      const loading = this.$loading({
        lock: true,
        text: "Loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      
      axios.get("/project/details", {
        params: {
          project_id: this.projectId
        }
      }).then(
        (response) => {
          const project = response.data.response.data.project;
          this.project = project;
          this.getProjectUsers();
          loading.close();
        },
        (error) => {
          loading.close();
          this.showAlert("Error", "Failed to load project details", false);
        }
      );
    },
    
    getProjectUsers() {
      const loading = this.$loading({
        lock: true,
        text: "Loading users...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      
      axios.get("/project/users", {
        params: {
          project_id: this.projectId
        }
      }).then(
        (response) => {
          if (response.data.response.error.error_code === 0) {
            const users = response.data.response.data.users || [];
            
            // Separate managers and viewers
            this.managers = users.filter(user => user.role === 'MANAGER');
            this.viewers = users.filter(user => user.role === 'VIEWER');
          }
          loading.close();
        },
        (error) => {
          loading.close();
          this.showAlert("Error", "Failed to load project users", false);
        }
      );
    },
    openInviteModal(preSelectedRole = null) {
      this.resetInviteUserModel();
      this.inviteUserModel.organisation_id = this.organisationId;
      this.inviteUserModel.project_id = this.projectId;
      this.inviteDialogVisible = true;

      if (!this.roles.length) {
        this.getUserRoles(preSelectedRole);
      } else if (preSelectedRole) {
        // Pre-select the role if roles are already loaded
        const roleObj = this.roles.find(r => r.role_name === preSelectedRole);
        if (roleObj) {
          this.inviteUserModel.user_role = roleObj.id;
        }
      }
    },
    getUserRoles(preSelectedRole = null) {
      axios.get("/user/roles").then((response) => {
        if (response && response.data.response.error.error_code === 0) {
          const roles = response.data.response.data.roles
            .map((role) => {
              if (role.type === "Administrative") {
                return role;
              }
            })
            .filter(Boolean);
          this.roles = roles;
          
          // Pre-select the role after loading
          if (preSelectedRole) {
            const roleObj = roles.find(r => r.role_name === preSelectedRole);
            if (roleObj) {
              this.inviteUserModel.user_role = roleObj.id;
            }
          }
        }
      });
    },
    checkEmail() {
      if (this.inviteUserModel.email) {
        axios
          .get(
            `/user/find/email?email=${encodeURIComponent(
              this.inviteUserModel.email
            )}`
          )
          .then((response) => {
            if (response && response.data.response.data) {
              this.inviteUserModel.user_id =
                response.data.response.data.user.id;
            }
          });
      }
    },
    submitInviteUser() {
      const vm = this;
      vm.$refs["inviteUserForm"].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: "Inviting user...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axios
            .put("/organisation/share/project", vm.inviteUserModel)
            .then((response) => {
              loading.close();
              if (response.data.response.error.error_code == 0) {
                vm.inviteDialogVisible = false;
                vm.showAlert("Success", response.data.response.error.msg, true);
                vm.getProjectDetails();
              } else {
                vm.showAlert(
                  "Error",
                  response.data.response.error.error_msg || "Failed to invite user",
                  false
                );
              }
            })
            .catch((error) => {
              loading.close();
              vm.inviteDialogVisible = false;
              vm.showAlert(
                "Error",
                error.response?.data?.response?.error?.error_msg || "An error occurred",
                false
              );
            });
        }
      });
    },
    resetInviteUserModel() {
      this.inviteUserModel = {
        organisation_id: "",
        first_name: "",
        last_name: "",
        email: "",
        user_id: null,
        project_id: this.projectId,
        user_role: "",
        note: "",
      };
    },
    removeUserConfirmation(user, project) {
      const body = {
        email: user.email,
        organisation_id: project.organisation_id,
        project_id: project.id,
        user_role: user.role_id,
      };
      let apiUrl = "/organisation/project/remove/user";
      new Swal({
        title: "Are you sure?",
        text: `You want to remove ${user.email}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-danger btn-fill",
        cancelButtonClass: "btn btn-success btn-fill",
        confirmButtonText: "yes",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (user.type === "invited_user") {
            body["role_id"] = user.role_id;
            apiUrl = "/organisation/project/invitation/delete";
          }
          this.removeUser(body, apiUrl);
        }
      });
    },
    removeUser(body, apiUrl) {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: "Removing user...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
        .delete(apiUrl, { data: { ...body } })
        .then((response) => {
          loading.close();
          if (response.data.response.error.error_code === 0) {
            vm.showAlert("Success", response.data.response.error.msg, true);
            vm.getProjectDetails();
          } else {
            vm.showAlert(
              "Error",
              response.data.response.error.error_msg,
              false
            );
          }
        })
        .catch((error) => {
          loading.close();
          vm.showAlert(
            "Error",
            error.response?.data?.response?.error?.error_msg || "An error occurred",
            false
          );
        });
    },
    goToAssignments() {
      this.$router.push(`/project/mv/${this.projectId}/assignments`);
    },
    showAlert(title, message, isSuccess) {
      new Swal({
        title: title,
        text: message,
        icon: isSuccess ? "success" : "error",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success btn-fill",
      });
    }
  },
  computed: {
    ...mapGetters("user", ["organisation"]),
    organisationId() {
      return this.organisation ? this.organisation.id : '';
    }
  },
  created() {
    this.getProjectDetails();
  },
};
</script>
<style lang="scss" scoped>
.project-sharing {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  padding: 24px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0;
}

.share-btn {
  background-color: var(--hw-pair1-secondary) !important;
  border-color: var(--hw-pair1-secondary) !important;
  border-radius: 8px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.android-btn {
  background-color: #10b981 !important;
  border-color: #10b981 !important;
  border-radius: 8px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #059669 !important;
    border-color: #059669 !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
  }
}

// Tabs styling
.user-tabs {
  margin-top: 24px;
  
  ::v-deep .el-tabs__header {
    margin-bottom: 24px;
  }
  
  ::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e2e8f0;
  }
  
  ::v-deep .el-tabs__item {
    font-size: 15px;
    font-weight: 500;
    color: #64748b;
    padding: 0 24px;
    height: 48px;
    line-height: 48px;
    transition: all 0.3s ease;
    
    &:hover {
      color: var(--hw-pair1-secondary);
    }
    
    &.is-active {
      color: var(--hw-pair1-secondary);
      font-weight: 600;
    }
  }
  
  ::v-deep .el-tabs__active-bar {
    height: 3px;
    background-color: var(--hw-pair1-secondary);
    border-radius: 3px 3px 0 0;
  }
}

.filter-controls {
  background-color: #fcfcfc;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.03);
  border: 1px solid #f0f0f0;
}

.filter-input ::v-deep .el-input__inner,
.filter-select ::v-deep .el-input__inner {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  height: 44px;
  line-height: 44px;
  transition: all 0.2s ease;
  background-color: #fff;

  &:focus {
    border-color: var(--hw-pair1-secondary);
    box-shadow: 0 0 0 2px rgba(var(--hw-pair1-secondary-rgb), 0.1);
  }
}

.reset-filter-btn {
  height: 44px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 13px;
  border: 1px solid #e0e0e0;
  color: #606266;
  background-color: #fff;
  
  &:hover {
    background-color: #f5f7fa;
    border-color: #dcdfe6;
    color: #409EFF;
  }
}

.select-icon {
  color: #909399;
  font-size: 16px;
  margin-right: 2px;
}

.user-table-container {
  margin-bottom: 24px;
  
  .custom-table {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    border: none;
    
    .even-row {
      background-color: #ffffff;
    }
    
    .odd-row {
      background-color: #f8fafc;
    }
    
    .el-table__row:hover {
      background-color: #f0f9ff !important;
    }
  }
}

// User avatar styles
.user-name {
  display: flex;
  align-items: center;
  gap: 10px;
  
  .user-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #0ea5e9;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
  }
}

// Email cell styles
.email-cell {
  display: flex;
  align-items: center;
  color: #475569;
}

// Note cell styles
.note-cell {
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

// Role tag styles
.role-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 50px;
  font-weight: 500;
  font-size: 13px;
  gap: 6px;
  
  .role-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
  }
  
  &.role-manager {
    background-color: #eff6ff;
    color: #2563eb;
    
    .role-dot {
      background-color: #2563eb;
    }
  }
  
  &.role-viewer {
    background-color: #f0f9ff;
    color: #0ea5e9;
    
    .role-dot {
      background-color: #0ea5e9;
    }
  }
  
  &.role-vaccinator {
    background-color: #ecfdf5;
    color: #10b981;
    
    .role-dot {
      background-color: #10b981;
    }
  }
  
  &.role-surveyor {
    background-color: #fef9c3;
    color: #ca8a04;
    
    .role-dot {
      background-color: #ca8a04;
    }
  }
  
  &.role-default {
    background-color: #f1f5f9;
    color: #64748b;
    
    .role-dot {
      background-color: #64748b;
    }
  }
}

// Status tag styles
.status-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 50px;
  font-weight: 500;
  font-size: 13px;
  gap: 6px;
  
  .status-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
  }
  
  &.status-active {
    background-color: #ecfdf5;
    color: #10b981;
    
    .status-indicator {
      background-color: #10b981;
    }
  }
  
  &.status-pending {
    background-color: #fff7ed;
    color: #f97316;
    
    .status-indicator {
      background-color: #f97316;
    }
  }
}

// Delete button styles
.delete-btn {
  border: none;
  background-color: #fee2e2;
  color: #ef4444;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #fecaca;
    transform: scale(1.05);
  }
  
  &:focus {
    background-color: #fee2e2;
  }
}

.no-results, .no-users, .loading-container {
  background-color: #f8fafc;
  border-radius: 10px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.invite-user-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e2e8f0;
    padding: 16px 24px;
    background-color: #f8fafc;
  }
  
  .el-dialog__body {
    padding: 24px;
  }
  
  .el-dialog__footer {
    border-top: 1px solid #e2e8f0;
    padding: 16px 24px;
    background-color: #f8fafc;
  }
}

@media (max-width: 767px) {
  .tab-scorlling {
    overflow-x: auto;
  }
  
  .user-table-container {
    overflow-x: auto;
  }
  
  .role-tag, .status-tag {
    padding: 4px 8px;
    font-size: 12px;
  }
}

@media (max-width: 450px) {
  .title-btn-center {
    flex-flow: wrap;
    justify-content: center !important;
    gap: 12px;
  }
  
  .project-sharing {
    padding: 16px;
  }
  
  .filter-controls {
    padding: 12px;
  }
}
</style>
